export default "__VITE_ASSET__62e208e7__"